import { render, staticRenderFns } from "./PowerOfAttorneyModal.vue?vue&type=template&id=224feaee&scoped=true&"
import script from "./PowerOfAttorneyModal.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyModal.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyModal.vue?vue&type=style&index=0&id=224feaee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224feaee",
  null
  
)

export default component.exports